/* eslint-disable react/prop-types */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  notification,
  Button as AntdButton,
  Upload,
  Select,
  Checkbox,
  Pagination,
} from 'antd';
import get from 'lodash/get';
import { CloudUploadOutlined, CloseOutlined } from '@ant-design/icons';
import {
  Package,
  Plus,
  Download,
  Upload as UploadIcon,
  Maximize2,
  Smartphone,
  FileSpreadsheet,
  History,
} from 'lucide-react';
import SpareOrderHistoryModal from './SpareOrderHistoryModal';
import { Button } from '@crc-evans/ui-components';
import './DPR/DPRSettingsSparesTab.css';
import '../pages/technical/HeatProfilePage.css';
import { useHeatStyleColumnFacets } from './technical/heatStyleColumnFacets';
import {
  fetchSparesDashBoardList,
  updateDashboardSpare,
  deleteDashboardSpare,
  fetchsparesEuipTypeList,
  fetchsparesEuipSNList,
  fetchSapKitNoList,
  fetchSapNoList,
  addSpareKit,
  addIndvSpare,
  publishDashboardList,
  fetchEuipSNList,
  fetchExcelSparesDashBoardList,
  fetchSubcategory,
} from '../redux/sparesDashboard/action';
import ExcelJS from 'exceljs';
import * as XLSX from 'xlsx';
import SparesExpandView from './SparesExpandView';
import SparesModernDataGrid from './DPR/SparesModernDataGrid';
import {
  OnGetSapNumberList,
  OnGetSparesItem,
  onUploadSparesExcel,
} from '../redux/sparesDashboard/saga';

/** Dark dropdown panel for Selects inside spares modals (portaled to body). */
const SPARES_MODAL_SELECT_PROPS = { dropdownClassName: 'dpr-settings-spares-select-dropdown' };

/** Heat-style column facet keys (must match `SparesModernDataGrid` filter column + enriched row fields). */
const SPARES_HEAT_FACET_KEYS = [
  'equipmentType',
  '__assignedDisplay',
  'subCategory',
  'sapKitNo',
  'sapNumber',
  'description',
  'targetStock',
  '__costStr',
  'pendingStock',
  'actualStock',
  'consumedQty',
  '__totalCostStr',
];

const SPARES_HEAT_FILTERS_EMPTY = SPARES_HEAT_FACET_KEYS.reduce((acc, k) => {
  acc[k] = '';
  return acc;
}, {});

const sparesFacetSearchCriteriaEmpty = {};

const SpareDashboard = (props) => {
  const {
    selectedProject,
    sparesEuipType,
    sparesEuipSn,
    equipmentSn,
    sparesSapKitNo,
    sparesSapNo,
    isSparesEuipTypeLoading,
    isSparesEuipSnLoading,
    isEquipmentSnLoading,
    isSparesSapKitNoLoading,
    isSparesSapNoLoading,
    equipDetails,
    projectTeamMembersAccessList,
    userAccessList,

    //
    onFetchSparesDashBoardList,
    onFetchExcelSparesDashBoardList,
    onGetPihEquipmentTypes,
    onGetSparesEquipmentSn,
    onGetEquipmentSn,
    onAddIndvSpare,
    onAddSpareKit,
    onFetchSubcategory,
    excelSparesList,
    isExcelSparesListLoading,
    onGetSparesEquipmentKitNo,
    onGetSparesEquipmentSapNo,
    onUpdateSpareList,
    onPublishDashboardList,
    sparesList,
    sparesDataCount,
    isSparesListLoading,
    onDeleteDashboardSpare,
    sparesSubcategoryData,
    isSparesDashSubcategoryLoading,
  } = props;

  const { Option } = Select;
  const [addIndSpareForm] = Form.useForm();
  const [spareKitForm] = Form.useForm();
  const [showAddModal, setShowAddModal] = useState(false);
  const [editDetailsForm] = Form.useForm();
  const [editValue, setEditValue] = useState(false);
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const [isPublishModalVisible, setIsPublishModalVisible] = useState(false);
  const [editSpareId, setEditSpareId] = useState('');
  const [parentId, setParentId] = useState('');
  const [assignedToSerialNumber, setAssignedToSerialNumber] = useState('');
  const [assignToEquipmentId, setAssignedToEquipmentId] = useState('');
  const [assignToPihEquipmentId, setAssignToPihEquipmentId] = useState('');
  const [selectedData, setSelectedData] = useState('');

  const [showAddSpareModal, setShowAddSpareModal] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);
  const [duplicatePayload, setDuplicatePayload] = useState(null);
  const [isKitModalVisible, setIsKitModalVisible] = useState(false);
  const [isChecked, setIsChecked] = useState('');
  const [currency, setCurrency] = useState('');
  const [equipmentTypeList, setEquipmentTypeList] = useState([]);
  const [serialNoList, setSerialNoList] = useState([]);
  const [sapKitNoList, setSapKitNoList] = useState([]);
  const [sapNumberList, setSapNumberList] = useState([]);
  const [serialNumberList, setSerialNumberList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  //
  const [equipmentType, setEquipmentType] = useState('');
  const [equipmentSN, setEquipmentSN] = useState('');
  const [subCategory, setSubCategory] = useState('');
  const [serialNoToAssign, setSerialNoToAssign] = useState(false);
  const [equipmentSapKitNo, setEquipmentSapKitNo] = useState('');
  const [equipmentSapNumber, setEquipmentSapNumber] = useState('');
  const [current, setCurrent] = useState(1);
  const [currentPagesize, setCurrentPagesize] = useState(20);
  const [newQty, setNewQty] = useState(0);
  const [pendingStock, setPendingStock] = useState(0);
  const [initialQty, setInitialQty] = useState('');
  const [isSerialNoToAssign, setIsSerialNoToAssign] = useState(false);
  const [totalLists, setTotalLists] = useState(0);
  const [sapNumberTotalList, setSapNumberTotalList] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  //
  const [equipmentTypeValue, setEquipmentTypeValue] = useState('');
  const [assignedToSerialNumberValue, setAssignedToSerialNumberValue] = useState('');
  const [equipmentSerialNumber, setEquipmentSerialNumber] = useState('');
  const [equipmentSubCategory, setEquipmentSubCategory] = useState('');
  const [sapKitNo, setSapKitNo] = useState('');
  const [sapNumber, setSapNumber] = useState('');
  const [description, setDescription] = useState('');
  const [unit, setUnit] = useState('');
  const [safetyStock, setSafetyStock] = useState('');
  const [cost, setCost] = useState('');
  const [location, setLocation] = useState('');
  const [showExpandModal, setShowExpandModal] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openOrderHistoryModal, setOpenOrderHistoryModal] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [disableFileUpload, setDisableFileUpload] = useState(false);

  const [localColFilters, setLocalColFilters] = useState({
    pendingStock: '',
    actualStock: '',
    consumedQty: '',
    totalCost: '',
  });
  const [heatColumnFilters, setHeatColumnFilters] = useState(() => ({ ...SPARES_HEAT_FILTERS_EMPTY }));
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState('asc');
  const [spareDeleteFlowActive, setSpareDeleteFlowActive] = useState(false);
  const [spareEditFlowActive, setSpareEditFlowActive] = useState(false);
  const prevSparesListLoadingRef = useRef(isSparesListLoading);

  const sparesEuipSnWithAll = useMemo(() => {
    const base = Array.isArray(sparesEuipSn) ? [...sparesEuipSn] : [];
    const hasAll = base.some((x) => x?.equipmentSerialNumber === 'All');
    if (!hasAll) base.unshift({ equipmentSerialNumber: 'All' });
    return base;
  }, [sparesEuipSn]);

  const isDisabled = isSerialNoToAssign || (equipmentSN === 'All' && serialNumberList.length === 0);

  /** Cognito groups: Redux is often empty on modern dashboard; match DPRSettingsTeamsTab / ConsumablesTab. */
  const resolveUserGroups = () => {
    const fromProps = Array.isArray(userAccessList) ? userAccessList : [];
    if (fromProps.length > 0) return fromProps;
    try {
      const raw = localStorage.getItem('UserGroup');
      if (raw == null || raw === '') return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return String(raw)
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean);
      }
    } catch {
      return [];
    }
  };

  const isGlobalAdminGroup = (groups) =>
    Array.isArray(groups) &&
    groups.some((g) => {
      const n = String(g || '').toLowerCase();
      return n === 'admin' || n === 'super-admin' || n === 'administrator';
    });

  // Spares write access: true = buttons disabled (legacy naming)
  const isButtonDisabled = () => {
    const groups = resolveUserGroups();
    if (isGlobalAdminGroup(groups)) return false;
    if (projectTeamMembersAccessList?.[0]?.isGuestUser) return true;
    if (
      projectTeamMembersAccessList?.[0]?.isNormalUser &&
      !projectTeamMembersAccessList?.[0]?.tabPermissions?.Spares?.write
    ) {
      return true;
    }
    return false;
  };

  const isWriteAccess = isButtonDisabled();

  const guardSparesWrite = () => {
    if (isButtonDisabled()) {
      notification.warning({
        message: 'Permission required',
        description: 'You do not have permission to edit or delete spares for this project.',
      });
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (selectedProject && selectedProject.id) {
      let obj = {
        projectId: selectedProject.id,
        pageSize: 20,
        pageNumber: 1,
      };
      onFetchSparesDashBoardList(obj);
      onFetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      onGetPihEquipmentTypes();
      onGetEquipmentSn({ projectId: selectedProject.id });
    }
  }, [selectedProject, equipDetails]);

  useEffect(() => {
    if (selectedProject?.id) {
      setHeatColumnFilters({ ...SPARES_HEAT_FILTERS_EMPTY });
    }
  }, [selectedProject?.id]);

  useEffect(() => {
    if (sparesList.length > totalLists && totalLists == 0) {
      setTotalLists(sparesList.length);
    }
  }, [sparesList, totalLists]);

  //Equipment Type List
  useEffect(() => {
    setEquipmentTypeList(removeEqTypeDuplicates(sparesEuipType));
  }, [sparesEuipType]);

  //Equipment  serial Number List
  useEffect(() => {
    setSerialNoList(removeDuplicates(sparesEuipSnWithAll));
  }, [sparesEuipSnWithAll]);

  //Equipment Sap Kit No List
  useEffect(() => {
    setSapKitNoList(removeSapDuplicates(sparesSapKitNo));
  }, [sparesSapKitNo]);

  //Equipment Sap Number List
  useEffect(() => {
    if (sapNumberTotalList && sapNumberTotalList.length > 0)
      setSapNumberList(removeSapNumberDuplicates(sparesSapNo));
  }, [sparesSapNo]);

  //Equipment Serial Number List
  useEffect(() => {
    setSerialNumberList(equipmentSn);
  }, [equipmentSn]);
  useEffect(() => {
    (async () => {
      const list = await OnGetSapNumberList();
      if (list && list.length > 0) setSapNumberTotalList(removeSapNumberDuplicates(list));
    })();
  }, []);

  //Equipment Sub category List
  useEffect(() => {
    const result = processSubCategories(sparesSubcategoryData);
    setSubCategoryList(removeSubCategoryDuplicates(result));
  }, [sparesSubcategoryData]);

  //add ALL to sub category list
  function processSubCategories(data) {
    // Filter out entries with empty or invalid subCategory values
    const validData = data.filter((item) => item.subCategory && item.subCategory.trim() !== '');

    // Check if 'All' is already present
    const hasAll = validData.some((item) => item.subCategory === 'All');

    // Add 'All' if not present
    if (!hasAll) {
      validData.unshift({ subCategory: 'All' });
    }

    return validData;
  }

  //remove duplicates for sub category
  const removeSubCategoryDuplicates = (arr) => {
    const uniqueObjects = {};
    arr.forEach((obj) => {
      uniqueObjects[obj.subCategory] = obj;
    });
    return Object.values(uniqueObjects);
  };

  //Remove duplicates for equipment type
  const removeEqTypeDuplicates = (arr) => {
    const uniqueObjects = {};
    arr.forEach((obj) => {
      uniqueObjects[obj.equipmentType] = obj;
    });
    return Object.values(uniqueObjects);
  };
  //remove duplicate for serial number
  const removeDuplicates = (arr) => {
    const uniqueSerialNumbers = new Set();
    return arr.filter((obj) => {
      const serialNumber = obj.equipmentSerialNumber;
      if (!uniqueSerialNumbers.has(serialNumber)) {
        uniqueSerialNumbers.add(serialNumber);
        return true;
      }
      return false;
    });
  };

  //remove duplicates for SpaKit Number
  const removeSapDuplicates = (arr) => {
    const uniqueObjects = {};
    arr.forEach((obj) => {
      uniqueObjects[obj.sapSparesKitNumber] = obj;
    });
    return Object.values(uniqueObjects);
  };

  //remove duplicates for Sap Number
  const removeSapNumberDuplicates = (arr) => {
    const uniqueObjects = {};
    arr.forEach((obj) => {
      uniqueObjects[obj.partSapNumber] = obj;
    });
    return Object.values(uniqueObjects);
  };

  const showEditModal = async (record) => {
    if (!guardSparesWrite()) return;
    setSpareEditFlowActive(false);
    let editData = null;
    if (record != null) {
      setEditSpareId(record.id);
      setAssignToPihEquipmentId(record.assignedToPihEquipmentId);
      setParentId(record.parentId);
      setAssignedToEquipmentId(record.assignedToEquipmentId);
      setAssignedToSerialNumber(record.assignedToSerialNumber);
      setIsChecked(record.isPublished);
      setCurrency(record.currency);
      setInitialQty(record.actualStock);
      setPendingStock(record.pendingStock);
      setNewQty(0);
    }
    setEditValue(true);
    editDetailsForm.setFieldsValue(record);
    setShowAddModal(true);
  };

  // Column search — client-side over full spares list (not current API page only)
  const handleFilterChange = (filterType, value, setterFunction) => {
    setterFunction(value);
    setCurrent(1);
  };

  const formatAssignedToCell = (v) => {
    if (Array.isArray(v) && v.length) return v.join(', ');
    if (v != null && v !== '') return String(v);
    return '—';
  };

  const totalCostDisplay = (record) => {
    const c = parseFloat(record.cost);
    const q = parseInt(record.initialQty, 10);
    if (Number.isFinite(c) && Number.isFinite(q)) {
      const t = (c * q).toFixed(2);
      const sym =
        record.currency === 'dollar' ? '$' : record.currency === 'pound' ? '£' : '€';
      return `${sym} ${t}`;
    }
    return '—';
  };

  const formatCostCell = (record) => {
    const sym =
      record.currency === 'dollar'
        ? '$'
        : record.currency === 'pound'
        ? '£'
        : record.currency === 'euro'
        ? '€'
        : '';
    const v = record.cost;
    if (v == null || v === '') return '—';
    return `${sym ? `${sym} ` : ''}${v}`;
  };

  const handleSparesHeatFilterChange = useCallback((key, value) => {
    setHeatColumnFilters((prev) => ({ ...prev, [key]: value }));
    setCurrent(1);
  }, []);

  const sparesFacetListRef = useRef([]);
  const sparesFacetSource = useMemo(() => {
    if (!selectedProject?.id) return [];
    const fullList =
      Array.isArray(excelSparesList) && excelSparesList.length > 0
        ? excelSparesList
        : Array.isArray(sparesList)
        ? sparesList
        : [];
    return fullList.map((row) => ({
      ...row,
      __assignedDisplay: formatAssignedToCell(row.assignedToSerialNumber),
      __costStr: formatCostCell(row),
      __totalCostStr: totalCostDisplay(row),
    }));
    // format* helpers are stable for matching table display strings
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject?.id, excelSparesList, sparesList]);

  const afterServerColumnFilters = useMemo(() => {
    let rows = [...sparesFacetSource];
    const q = (s) => (s || '').trim().toLowerCase();
    const includes = (val, term) => String(val ?? '').toLowerCase().includes(term);

    if (q(equipmentTypeValue)) {
      const t = q(equipmentTypeValue);
      rows = rows.filter((r) => includes(r.equipmentType, t));
    }
    if (q(assignedToSerialNumberValue)) {
      const t = q(assignedToSerialNumberValue);
      rows = rows.filter((r) => includes(formatAssignedToCell(r.assignedToSerialNumber), t));
    }
    if (q(equipmentSubCategory)) {
      const t = q(equipmentSubCategory);
      rows = rows.filter((r) => includes(r.subCategory, t));
    }
    if (q(sapKitNo)) {
      const t = q(sapKitNo);
      rows = rows.filter((r) => includes(r.sapKitNo, t));
    }
    if (q(sapNumber)) {
      const t = q(sapNumber);
      rows = rows.filter((r) => includes(r.sapNumber, t));
    }
    if (q(description)) {
      const t = q(description);
      rows = rows.filter((r) => includes(r.description, t));
    }
    if (q(safetyStock)) {
      const t = q(safetyStock);
      rows = rows.filter((r) => includes(r.targetStock, t));
    }
    if (q(cost)) {
      const t = q(cost);
      rows = rows.filter((r) => includes(r.cost, t));
    }
    return rows;
  }, [
    sparesFacetSource,
    equipmentTypeValue,
    assignedToSerialNumberValue,
    equipmentSubCategory,
    sapKitNo,
    sapNumber,
    description,
    safetyStock,
    cost,
  ]);

  sparesFacetListRef.current = sparesFacetSource;

  const fetchSparesFacetRows = useCallback(async () => {
    const pl = sparesFacetListRef.current;
    return Array.isArray(pl) ? [...pl] : [];
  }, []);

  const { applyFacetClientFilter, renderTextColumnFilterTrigger } = useHeatStyleColumnFacets({
    enabled: Boolean(selectedProject?.id),
    filterableColumns: SPARES_HEAT_FACET_KEYS,
    listCount: sparesFacetSource.length,
    projectList: sparesFacetSource,
    searchCriteria: sparesFacetSearchCriteriaEmpty,
    columnFilters: heatColumnFilters,
    onColumnFilterChange: handleSparesHeatFilterChange,
    fetchFacetRows: fetchSparesFacetRows,
  });

  const afterHeatColumnFacetRows = useMemo(() => {
    let rows = [...afterServerColumnFilters];
    SPARES_HEAT_FACET_KEYS.forEach((key) => {
      const raw = (heatColumnFilters[key] || '').trim();
      if (!raw) return;
      const t = raw.toLowerCase();
      rows = rows.filter((r) => String(get(r, key) ?? '').toLowerCase().includes(t));
    });
    return applyFacetClientFilter(rows);
  }, [afterServerColumnFilters, heatColumnFilters, applyFacetClientFilter]);

  // totalCostDisplay is stable logic; including it in deps would re-run every render
  const mergedFilteredRows = useMemo(() => {
    let rows = [...afterHeatColumnFacetRows];
    const f = localColFilters;
    const q = (s) => (s || '').trim().toLowerCase();
    if (q(f.pendingStock)) {
      const t = q(f.pendingStock);
      rows = rows.filter((r) => String(r.pendingStock ?? '').toLowerCase().includes(t));
    }
    if (q(f.actualStock)) {
      const t = q(f.actualStock);
      rows = rows.filter((r) => String(r.actualStock ?? '').toLowerCase().includes(t));
    }
    if (q(f.consumedQty)) {
      const t = q(f.consumedQty);
      rows = rows.filter((r) => String(r.consumedQty ?? '').toLowerCase().includes(t));
    }
    if (q(f.totalCost)) {
      const t = q(f.totalCost);
      rows = rows.filter((r) => totalCostDisplay(r).toLowerCase().includes(t));
    }
    return rows;
  // eslint-disable-next-line react-hooks/exhaustive-deps -- totalCostDisplay is defined above and only used for string match
  }, [afterHeatColumnFacetRows, localColFilters]);

  const sortedSparesRows = useMemo(() => {
    if (!sortKey) return mergedFilteredRows;
    const dir = sortDir === 'asc' ? 1 : -1;
    const num = (v) => {
      const n = parseFloat(v);
      return Number.isFinite(n) ? n : null;
    };
    return [...mergedFilteredRows].sort((a, b) => {
      switch (sortKey) {
        case 'equipmentType':
          return dir * String(a.equipmentType ?? '').localeCompare(String(b.equipmentType ?? ''));
        case 'assignedToSerialNumber': {
          const va = formatAssignedToCell(a.assignedToSerialNumber);
          const vb = formatAssignedToCell(b.assignedToSerialNumber);
          return dir * va.localeCompare(vb);
        }
        case 'subCategory':
          return dir * String(a.subCategory ?? '').localeCompare(String(b.subCategory ?? ''));
        case 'sapKitNo':
          return dir * String(a.sapKitNo ?? '').localeCompare(String(b.sapKitNo ?? ''));
        case 'sapNumber':
          return dir * String(a.sapNumber ?? '').localeCompare(String(b.sapNumber ?? ''));
        case 'description':
          return dir * String(a.description ?? '').localeCompare(String(b.description ?? ''));
        case 'targetStock': {
          const na = num(a.targetStock);
          const nb = num(b.targetStock);
          if (na != null && nb != null) return dir * (na - nb);
          return dir * String(a.targetStock ?? '').localeCompare(String(b.targetStock ?? ''));
        }
        case 'cost': {
          const na = num(a.cost);
          const nb = num(b.cost);
          if (na != null && nb != null) return dir * (na - nb);
          return dir * String(a.cost ?? '').localeCompare(String(b.cost ?? ''));
        }
        case 'pendingStock':
          return (
            dir *
            ((parseInt(a.pendingStock, 10) || 0) - (parseInt(b.pendingStock, 10) || 0))
          );
        case 'actualStock':
          return (
            dir * ((parseInt(a.actualStock, 10) || 0) - (parseInt(b.actualStock, 10) || 0))
          );
        case 'consumedQty':
          return (
            dir * ((parseInt(a.consumedQty, 10) || 0) - (parseInt(b.consumedQty, 10) || 0))
          );
        case 'totalCost': {
          const costA = num(a.cost);
          const costB = num(b.cost);
          const qa = parseInt(a.initialQty, 10) || 0;
          const qb = parseInt(b.initialQty, 10) || 0;
          const ta = costA != null ? costA * qa : 0;
          const tb = costB != null ? costB * qb : 0;
          return dir * (ta - tb);
        }
        case 'isPublished':
          return dir * ((a.isPublished ? 1 : 0) - (b.isPublished ? 1 : 0));
        default:
          return 0;
      }
    });
  }, [mergedFilteredRows, sortKey, sortDir]);

  const filteredSparesCount = sortedSparesRows.length;
  const totalSparesCount = sparesFacetSource.length;

  const paginatedSparesRows = useMemo(() => {
    const start = (current - 1) * currentPagesize;
    return sortedSparesRows.slice(start, start + currentPagesize);
  }, [sortedSparesRows, current, currentPagesize]);

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(filteredSparesCount / currentPagesize) || 1);
    if (current > maxPage) setCurrent(maxPage);
  }, [filteredSparesCount, current, currentPagesize]);

  const toggleSparesSort = (key) => {
    if (sortKey !== key) {
      setSortKey(key);
      setSortDir('asc');
    } else if (sortDir === 'asc') {
      setSortDir('desc');
    } else {
      setSortKey(null);
      setSortDir('asc');
    }
  };

  const onLocalColFilterChange = (field, value) => {
    setLocalColFilters((prev) => ({ ...prev, [field]: value }));
    setCurrent(1);
  };

  const showModal = () => {
    if (selectedProject) {
      resetAddIndvSpareForm();
      setShowAddSpareModal(true);
    } else {
      notification.warn({ message: 'Select Project to add data.' });
    }
  };

  const handleCancel = () => {
    editDetailsForm.resetFields(); //resetting input fields
    setShowAddModal(false);
    setEditValue(false);
    setSpareEditFlowActive(false);
  };

  function isSerialNumberAvailable(data, serialNumber) {
    for (let i = 0; i < data.length; i++) {
      if (data[i].serialNumber === serialNumber) {
        return true;
      }
    }
    return false;
  }

  function filterEquipmentList(data, equipmentType) {
    return data.filter((item) => item.equipmentType == equipmentType);
  }
  /** On change function to select Equipment */
  const onChangeSpareEquipmentType = async (value) => {
    spareKitForm.setFieldsValue({ subCategory: '', sapKitNo: '', assignTo: '' });
    addIndSpareForm.setFieldsValue({ subCategory: '', sapKitNo: '' });
    // setEquipmentSN('');
    setSubCategory('');
    setIsSerialNoToAssign(false);
    if (value) {
      setEquipmentType(value);
      await onFetchSubcategory({ pihEquipmentType: value, pihEquipmentSubcategory: 'subCategory' });
      await onGetSparesEquipmentKitNo({
        sapSparesKitNumber: 'sapSparesKitNumber',
        pihEquipmentType: value,
      });
      // await onGetSparesEquipmentSn({ pihEquipmentType: value });
    } else {
      setSubCategoryList([]);
      setSapKitNoList([]);
      // setSapNumberList([]);
      setEquipmentType('');
      setSubCategory('');
      setEquipmentSapKitNo('');
    }
  };

  /** On change function to select Equipment serial number */
  const onChangeSpareEquipmentSn = async (value) => {
    spareKitForm.setFieldsValue({ sapKitNo: '' });
    addIndSpareForm.setFieldsValue({ sapKitNo: '', sapNumber: '' });
    if (value) {
      const isAvbl = isSerialNumberAvailable(equipmentSn, value);
      if (isAvbl) {
        setSerialNoToAssign(true);
        setIsSerialNoToAssign(false);
        spareKitForm.setFieldsValue({ assignTo: value });
      } else {
        if (value !== 'All') {
          setIsSerialNoToAssign(true);
        } else {
          setIsSerialNoToAssign(false);
        }
        setSerialNoToAssign(false);
        spareKitForm.setFieldsValue({ assignTo: '' });
      }
      if (value == 'All' && equipmentType !== '') {
        const filteredEqpList = filterEquipmentList(equipmentSn, equipmentType);
        setSerialNumberList(filteredEqpList);
      } else {
        setSerialNumberList(equipmentSn);
      }
      setEquipmentSN(value);
      await onGetSparesEquipmentKitNo({
        sapKitNo: 'sapKitNo',
        pihEquipmentType: equipmentType,
        pihEquipmentSn: value,
      });
    } else {
      setSapKitNoList([]);
      setSapNumberList([]);
      setEquipmentSN('');
      setEquipmentSapKitNo('');
      setIsSerialNoToAssign(false);
      setSerialNoToAssign(false);
      spareKitForm.setFieldsValue({ assignTo: '' });
    }
  };

  /** On change function to select Equipment sapKitNo */
  const onChangesapKitNo = async (value) => {
    addIndSpareForm.setFieldsValue({ sapNumber: '' });
    if (value) {
      setEquipmentSapKitNo(value);
      await onGetSparesEquipmentSapNo({
        pihEquipmentType: equipmentType,
        pihEquipmentSapKitNo: value,
        partSapNumber: 'partSapNumber',
      });
    } else {
      setSapNumberList([]);
      setEquipmentSapKitNo('');
      setEquipmentSapNumber('');
    }
  };

  // Conver list of data into Excel sheet
  const handleDownloadExcelSheet = async () => {
    if (isExcelSparesListLoading) {
      notification.warning({
        message: 'Wait a moment, Spares List is Loading...',
      });
      return;
    }
    const workbook = new ExcelJS.Workbook();
    const sparesListSheet = workbook.addWorksheet('SparesOrderList');

    sparesListSheet.columns = [
      { header: 'Equipment Type', key: 'equipmentType', width: 18 },
      { header: 'Assigned to Serial Number', key: 'assignedToSerialNumber', width: 25 },
      { header: 'SAP Kit No', key: 'sapKitNo', width: 20 },
      { header: 'SAP Number', key: 'sapNumber', width: 20 },
      { header: 'Description', key: 'description', width: 30 },
      { header: 'Location', key: 'location', width: 20 },
      { header: 'Unit', key: 'unit', width: 10 },
      { header: 'Currency', key: 'currency', width: 10 },
      { header: 'Target Stock', key: 'targetStock', width: 15 },
      { header: 'Actual Stock', key: 'actualStock', width: 15 },
      { header: 'Pending Stock', key: 'pendingStock', width: 15 },
      { header: 'Consumed Quantity', key: 'consumedQty', width: 15 },
      { header: 'Cost', key: 'cost', width: 10 },
      { header: 'Is Published', key: 'isPublished', width: 12 },
      //  { header: 'Created At', key: 'createdAt', width: 25 },
    ];

    const headerRow = sparesListSheet.getRow(1);
    headerRow.height = 40;

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    excelSparesList.forEach((row) => {
      // Parse assignedToSerialNumber from JSON array to comma-separated string
      if (row.assignedToSerialNumber) {
        try {
          // First parse the outer array
          const outerArray = JSON.parse(row.assignedToSerialNumber);
          // Then parse each inner array and join with commas
          const parsedValues = outerArray.map((item) => {
            try {
              const innerArray = JSON.parse(item);
              return innerArray.join(', ');
            } catch (e) {
              return item;
            }
          });
          row.assignedToSerialNumber = parsedValues.join(', ');
        } catch (e) {
          console.log('Error parsing assignedToSerialNumber:', e);
          row.assignedToSerialNumber = row.assignedToSerialNumber.toString();
        }
      }

      row.isPublished = row.isPublished === 0 ? 'No' : 'Yes';

      // Ensure consumedQty is properly handled for Excel export
      if (row.consumedQty === undefined || row.consumedQty === null) {
        row.consumedQty = 0;
      }

      // row.createdAt = new Date(row.createdAt).toLocaleString();
      sparesListSheet.addRow(row);
    });

    // Write to buffer
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'sparesList.xlsx';
    link.click();
  };
  // Conver list of data into Excel sheet
  const handleDownloadTemplate = async () => {
    const workbook = new ExcelJS.Workbook();
    const sparesListSheet = workbook.addWorksheet('SparesOrderList');

    sparesListSheet.columns = [
      { header: 'Equipment Type', key: 'equipmentType', width: 18 },
      { header: 'Assigned to Serial Number', key: 'assignedToSerialNumber', width: 25 },
      { header: 'SAP Kit No', key: 'sapKitNo', width: 20 },
      { header: 'SAP Number', key: 'sapNumber', width: 20 },
      { header: 'Description', key: 'description', width: 30 },
      { header: 'Location', key: 'location', width: 20 },
      { header: 'Unit', key: 'unit', width: 10 },
      { header: 'Currency', key: 'currency', width: 10 },
      { header: 'Target Stock', key: 'targetStock', width: 15 },
      { header: 'Actual Stock', key: 'actualStock', width: 15 },
      { header: 'Pending Stock', key: 'pendingStock', width: 15 },
      { header: 'Cost', key: 'cost', width: 10 },
      { header: 'Is Published', key: 'isPublished', width: 12 },
      //  { header: 'Created At', key: 'createdAt', width: 25 },
    ];

    const headerRow = sparesListSheet.getRow(1);
    headerRow.height = 40;

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
    });

    // Write to buffer
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'spares template.xlsx';
    link.click();
  };

  const handleAdd = async () => {
    editDetailsForm
      .validateFields()
      .then(async (data) => {
          if (editValue) {
            const payload = {
              projectSparePart: {
                id: editSpareId,
                equipmentType: data.equipmentType,
                assignedToSerialNumber: assignedToSerialNumber,
                subCategory: data.subCategory,
                sapKitNo: data.sapKitNo,
                sapNumber: data.sapNumber,
                description: data.description,
                cost: data.cost,
                pendingStock: data.pendingStock,
                currency: data.currency,
                location: data.location,
                assignedToPihEquipmentId: assignToPihEquipmentId,
                assignedToEquipmentId: assignToEquipmentId,
                parentId: parentId,
                isPublished: isChecked,
                projectId: selectedProject.id,
              },
            };
            /* Saga shows success/error toasts and refetches; close when loading finishes */
            setSpareEditFlowActive(true);
            onUpdateSpareList({ data: payload, selectedProject: selectedProject });
          } else {
            let data = {
              name: name,
              productCode: productCode,
              quantityInStock: initialQuantity,
              safetyStock: safetyStock,
              projectId: selectedProject.id,
            };
            // let res = await onAddConsumables(data)
            if (!isConsumablesLoading) {
              setBulkUplaodModal(false);
              setShowAddModal(false);
              editDetailsForm.resetFields(); //resetting input fields
            }
          }
      })
      .catch((err) => console.log(err));
  };

  const handlePublishApp = async () => {
    await onPublishDashboardList({ selectedProject: selectedProject });
  };

  /* Do not close the edit/add spare modal here — list refetch toggles loading and would dismiss the modal mid-edit. */
  useEffect(() => {
    if (!isSparesListLoading) {
      setIsPublishModalVisible(false);
      setIsKitModalVisible(false);
    }
  }, [isSparesListLoading]);

  const showDeleteModal = (record) => {
    if (!guardSparesWrite()) return;
    setIsDeleteModalVisible(true);
    setSelectedData(record);
  };

  const handlePublish = (record) => {
    setIsPublishModalVisible(true);
  };

  const handleDeleteCancel = () => {
    setSpareDeleteFlowActive(false);
    setIsDeleteModalVisible(false);
    setSelectedData('');
  };

  const handlePublishCancel = () => {
    setIsPublishModalVisible(false);
  };

  const handleDeleteOk = () => {
    if (!selectedData?.id) return;
    setSpareDeleteFlowActive(true);
    onDeleteDashboardSpare({ id: selectedData.id, selectedProject: selectedProject });
  };

  /* Close after saga refetch: only when loading goes true → false (avoids closing if list was idle). */
  useEffect(() => {
    const wasLoading = prevSparesListLoadingRef.current;
    prevSparesListLoadingRef.current = isSparesListLoading;
    const finishedFetch = wasLoading && !isSparesListLoading;
    if (!finishedFetch) return;
    if (spareDeleteFlowActive) {
      setSpareDeleteFlowActive(false);
      setIsDeleteModalVisible(false);
      setSelectedData('');
    }
    if (spareEditFlowActive) {
      setSpareEditFlowActive(false);
      setShowAddModal(false);
      setEditValue(false);
      editDetailsForm.resetFields();
    }
  }, [isSparesListLoading, spareDeleteFlowActive, spareEditFlowActive, editDetailsForm]);

  const resetSpareKitForm = () => {
    spareKitForm.resetFields();
    setIsKitModalVisible(false);
    setSerialNoList([]);
    setSapKitNoList([]);
    setEquipmentType('');
    setSerialNumberList([]);
    // setEquipmentSN('');
    setSubCategory('');
    setEquipmentSapKitNo('');
    setSerialNoToAssign(false);
    setIsSerialNoToAssign(false);
  };

  const handlespareModalCancel = () => {
    resetSpareKitForm();
    addIndSpareForm.resetFields();
  };

  const resetAddIndvSpareForm = () => {
    addIndSpareForm.resetFields();
    setShowAddSpareModal(false);
    setSerialNoList([]);
    setSapKitNoList([]);
    setSapNumberList([]);
    setEquipmentType('');
    // setEquipmentSN('');
    setSubCategory('');
    setEquipmentSapKitNo('');
    setEquipmentSapNumber('');
  };

  const handleAddIndvSpareModalCancel = () => {
    if (sparesEuipType) {
      addIndSpareForm.resetFields();
      setEquipmentTypeList(removeEqTypeDuplicates(sparesEuipType));
    }
    addIndSpareForm.setFieldsValue({ subCategory: '' });
    addIndSpareForm.setFieldsValue({ sapKitNo: '' });
    addIndSpareForm.setFieldsValue({ equipmentType: '' });

    resetAddIndvSpareForm();
  };

  const handleSpareAdd = async () => {
    try {
      const data = await spareKitForm.validateFields();

      if (
        !data.equipmentType ||
        !data.sapKitNo ||
        !data.quantity
      ) {
        notification.warning({
          message: 'Fill all the required fields!',
        });
        return;
      }
      const assignedObj = data.assignTo ? equipmentSn?.find((item) => item.serialNumber == data.assignTo) : null;

      if (data.quantity < 1) {
        notification.warning({
          message: 'Please add quantity to proceed!',
        });
        return;
      }

      const payload = {
        projectId: selectedProject.id,
        equipmentType: data.equipmentType,
        subCategory: data.subCategory || '',
        sapKitNo: data.sapKitNo,
        quantity: data.quantity,
        location: data.location,
        assignedToSerialNumber: data.assignTo || '',
        assignedToPihEquipmentId: assignedObj?.pihEquipmentId || null,
        assignedToEquipmentId: assignedObj?.equipmentId || null,
      };
      // const payload = {
      //     "projectId": selectedProject.id,
      //     "equipmentType": data.equipmentType,
      //     "equipmentSerialNumber": data.equipmentSerialNumber,
      //     "sapKitNo": data.sapKitNo,
      //     "quantity": data.quantity,
      //     "assignedToSerialNumber":equipmentSN == 'All' ? data.assignTo : data.equipmentSerialNumber
      // };

      await onAddSpareKit({ payload, selectedProject });
      setTimeout(resetSpareKitForm, 1000);
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddIndvSpare = async () => {
    try {
      const data = await addIndSpareForm.validateFields();

      if (
        !data.equipmentType ||
        !data.sapKitNo ||
        !data.sapNumber ||
        !data.quantity
      ) {
        notification.warning({
          message: 'Fill all the required fields!',
        });
        return;
      }

      const assignedObj = data.assignTo ? equipmentSn?.find((item) => item.pihEquipmentId == data.assignTo) : null;

      if (data.quantity < 1) {
        notification.warning({
          message: 'Please add quantity to proceed!',
        });
        return;
      }

      const existingSpare = sparesList.find(
        (spare) =>
          spare.equipmentType === data.equipmentType &&
          spare.sapKitNo === data.sapKitNo &&
          spare.sapNumber === data.sapNumber
      );

      const payload = {
        projectId: selectedProject.id,
        equipmentType: data.equipmentType,
        subCategory: data.subCategory || '',
        sapKitNo: data.sapKitNo,
        sapNumber: data.sapNumber,
        quantity: data.quantity,
        location: data.location,
        assignedToPihEquipmentId: assignedObj?.pihEquipmentId || null,
        assignedToEquipmentId: assignedObj?.equipmentId || null,
        assignedToSerialNumber: assignedObj?.serialNumber || '',
      };

      const submitPayload = async () => {
        try {
          await onAddIndvSpare({ payload, selectedProject });
          setTimeout(handleAddIndvSpareModalCancel(), 1000);
        } catch (err) {
          console.log(err);
        }
      };

      if (existingSpare) {
        setDuplicatePayload({ payload, selectedProject, existingSpare });
        setShowDuplicateModal(true);
      } else {
        submitPayload();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleKeyPress = (e) => {
    const charCode = e.charCode;
    if (charCode < 48 || charCode > 57) {
      e.preventDefault();
    }
  };

  const showSparesExpand = () => {
    if (selectedProject) {
      // setBillingTitle("Update Monthly Record");
      setShowExpandModal(true);
    } else {
      notification.warn({ message: 'Select project to see expand view' });
    }
  };

  /** Setting Properties for upload file  */
  const fileProps = {
    listType: 'text',
    showUploadList: {
      showRemoveIcon: true,
      showPreviewIcon: false,
      removeIcon: (
        <CloseOutlined
          className="dpr-settings-spares-upload-remove-icon"
          aria-label="Remove file"
        />
      ),
    },
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      setFileList([file]);
      setDisableFileUpload(true);
      // }
      return false;
    },
    fileList,
  };

  /** Removing file and closing upload window on cancel */
  const handleCancelUploadFile = () => {
    setFileList([]);
    setUploading(false);
    setOpenUploadModal(false);
    setDisableFileUpload(false);
  };

  const handleUploadFile = async () => {
    let payload = {};
    if (fileList.length > 0) {
      payload.certificate = fileList;
      setUploading(true);
      const res = await onUploadSparesExcel(payload, selectedProject.id);
      if (res) {
        let obj = {
          projectId: selectedProject.id,
          pageSize: 10,
          pageNumber: 1,
        };
        await onFetchSparesDashBoardList(obj);
        // Refresh Excel spares list to get updated data for export
        await onFetchExcelSparesDashBoardList({ projectId: selectedProject.id });
      }
      setUploading(false);
      await handleCancelUploadFile();
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  const OnChangeSapNumber = async (value) => {
    if (value && value != '') {
      setEquipmentSapNumber(value);
      const list = await OnGetSparesItem(value);
      if (list && list.rows.length > 0) {
        const items = removeEqTypeDuplicates(list.rows);
        setEquipmentTypeList(items);
        setFetchLoading(true);
        // if (items && items.length > 0 && items[0].equipmentType) {
        //     setEquipmentType(items[0].equipmentType);
        //     await onFetchSubcategory({ pihEquipmentType: items[0].equipmentType, pihEquipmentSubcategory: 'subCategory' });
        //     await onGetSparesEquipmentKitNo({ sapSparesKitNumber: 'sapSparesKitNumber', pihEquipmentType: items[0].equipmentType });
        //     addIndSpareForm.setFieldsValue({ equipmentType: items[0].equipmentType });
        // }
      }
    } else {
      setEquipmentSapNumber(value);
      setEquipmentTypeList(removeEqTypeDuplicates(sparesEuipType));

      addIndSpareForm.setFieldsValue({ equipmentType: '' });
      addIndSpareForm.setFieldsValue({ sapKitNo: '' });
    }
  };
  const onChangeSapNumber1 = async (value) => {
    setEquipmentSapNumber(value);
    if (!value || value == '') {
      setEquipmentTypeList(removeEqTypeDuplicates(sparesEuipType));
      // setEquipmentType('');
      // setEquipmentSapKitNo('');
      // addIndSpareForm.setFieldsValue({ equipmentType: '' });
      //addIndSpareForm.setFieldsValue({ sapKitNo: '' });
    }
  };

  useEffect(() => {
    (async () => {
      if (
        equipmentSapNumber !== '' &&
        equipmentTypeList &&
        equipmentTypeList.length > 0 &&
        equipmentTypeList[0].equipmentType
      ) {
        setEquipmentType(equipmentTypeList[0].equipmentType);
        await onFetchSubcategory({
          pihEquipmentType: equipmentTypeList[0].equipmentType,
          pihEquipmentSubcategory: 'subCategory',
        });
        await onGetSparesEquipmentKitNo({
          sapSparesKitNumber: 'sapSparesKitNumber',
          pihEquipmentType: equipmentTypeList[0].equipmentType,
        });
        addIndSpareForm.setFieldsValue({ equipmentType: equipmentTypeList[0].equipmentType });
      }
    })();
    setFetchLoading(false);
  }, [equipmentTypeList]);

  useEffect(() => {
    if (equipmentSapNumber !== '' && subCategoryList && subCategoryList.length > 0) {
      const subCategory =
        subCategoryList.length > 1
          ? subCategoryList[1]?.subCategory
          : subCategoryList[0]?.subCategory;

      addIndSpareForm.setFieldsValue({
        subCategory: subCategory === 'All' ? 'All' : subCategory,
      });
    }
  }, [subCategoryList]);

  useEffect(() => {
    if (
      equipmentSapNumber != '' &&
      sapKitNoList &&
      sapKitNoList.length > 0 &&
      sapKitNoList[0].sapSparesKitNumber
    ) {
      const sapSparesKitNumber = sapKitNoList[0].sapSparesKitNumber;
      setEquipmentSapKitNo(sapSparesKitNumber);
      addIndSpareForm.setFieldsValue({ sapKitNo: sapSparesKitNumber });
    }
  }, [sapKitNoList]);

  if (!selectedProject?.id) {
    return (
      <div className="dpr-settings-spares-tab">
        <div className="dpr-settings-spares-card">
          <p style={{ margin: 0, color: '#64748B' }}>Select a project to manage spares.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-100 dpr-settings-spares-tab">
      <div className="dpr-settings-spares-card">
        <div className="dpr-settings-spares-header">
          <div className="dpr-settings-spares-header-left">
            <div className="dpr-settings-spares-icon-wrap">
              <Package size={24} aria-hidden />
            </div>
            <div className="dpr-settings-spares-header-content">
              <div className="dpr-settings-spares-title-row">
                <h3 className="dpr-settings-spares-title">List of Spares</h3>
                <span className="dpr-settings-spares-summary">
                  {filteredSparesCount !== totalSparesCount
                    ? `${filteredSparesCount} of ${totalSparesCount}`
                    : `${totalSparesCount} total`}
                </span>
              </div>
              <p className="dpr-settings-spares-description">
                List and manage spares.
              </p>
            </div>
          </div>
          <div className="dpr-settings-spares-actions">
            <Button
              label="Export Excel"
              variant="tertiary"
              size="small"
              icon={FileSpreadsheet}
              onClick={handleDownloadExcelSheet}
            />
            <Button
              label="Template"
              variant="tertiary"
              size="small"
              icon={Download}
              onClick={handleDownloadTemplate}
            />
            <Button
              label="Upload"
              variant="tertiary"
              size="small"
              icon={UploadIcon}
              onClick={() => setOpenUploadModal(true)}
            />
            <Button
              label="Order history"
              variant="tertiary"
              size="small"
              icon={History}
              onClick={() => setOpenOrderHistoryModal(true)}
            />
            <Button
              label="Expand"
              variant="tertiary"
              size="small"
              icon={Maximize2}
              onClick={showSparesExpand}
            />
            <Button
              label="Publish in app"
              variant="tertiary"
              size="small"
              icon={Smartphone}
              onClick={() => !isWriteAccess && handlePublish()}
              disabled={isWriteAccess}
            />
            <Button
              label="Add kit"
              variant="tertiary"
              size="small"
              icon={Plus}
              onClick={() => !isWriteAccess && setIsKitModalVisible(true)}
              disabled={isWriteAccess}
            />
            <Button
              label="Add individual spare"
              variant="primary"
              size="small"
              icon={Plus}
              onClick={showModal}
              disabled={isWriteAccess}
            />
          </div>
        </div>

        <SparesModernDataGrid
          sortedRows={paginatedSparesRows}
          isLoading={isExcelSparesListLoading || isSparesListLoading}
          current={current}
          pageSize={currentPagesize}
          sortKey={sortKey}
          sortDir={sortDir}
          onToggleSort={toggleSparesSort}
          formatAssignedToCell={formatAssignedToCell}
          formatCostCell={formatCostCell}
          totalCostDisplay={totalCostDisplay}
          onEdit={showEditModal}
          onDelete={showDeleteModal}
          equipmentTypeValue={equipmentTypeValue}
          assignedToSerialNumberValue={assignedToSerialNumberValue}
          equipmentSubCategory={equipmentSubCategory}
          sapKitNo={sapKitNo}
          sapNumber={sapNumber}
          description={description}
          safetyStock={safetyStock}
          cost={cost}
          onServerFilterChange={handleFilterChange}
          setEquipmentTypeValue={setEquipmentTypeValue}
          setAssignedToSerialNumberValue={setAssignedToSerialNumberValue}
          setEquipmentSubCategory={setEquipmentSubCategory}
          setSapKitNo={setSapKitNo}
          setSapNumber={setSapNumber}
          setDescription={setDescription}
          setSafetyStock={setSafetyStock}
          setCost={setCost}
          localColFilters={localColFilters}
          onLocalColFilterChange={onLocalColFilterChange}
          renderTextColumnFilterTrigger={renderTextColumnFilterTrigger}
        />

        {filteredSparesCount > 0 && (
          <div className="dpr-settings-spares-pagination">
            <Pagination
              className="heat-profile-pagination"
              showSizeChanger
              pageSizeOptions={['10', '20', '50', '100']}
              current={current}
              pageSize={currentPagesize}
              total={filteredSparesCount}
              onChange={(pageNumber, pageSize) => {
                if (pageSize != null && pageSize !== currentPagesize) {
                  setCurrentPagesize(pageSize);
                  setCurrent(1);
                } else {
                  setCurrent(pageNumber);
                }
              }}
            />
          </div>
        )}
      </div>

      {/* Add / edit spare — modern dark glass modal */}
      <Modal
        width={720}
        className="dpr-settings-spares-form-modal dpr-settings-spares-modern-modal"
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        title={editValue ? 'Edit spare' : 'Create new spare'}
        centered
        visible={showAddModal}
        maskClosable={!(editValue && spareEditFlowActive && isSparesListLoading)}
        destroyOnClose
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button label="Cancel" variant="tertiary" size="medium" onClick={handleCancel} />
            <Button
              label={
                editValue
                  ? spareEditFlowActive && isSparesListLoading
                    ? 'Updating…'
                    : 'Update'
                  : isSparesListLoading
                  ? 'Adding…'
                  : 'Add'
              }
              variant="primary"
              size="medium"
              onClick={handleAdd}
              disabled={editValue ? spareEditFlowActive && isSparesListLoading : isSparesListLoading}
            />
          </div>
        }
      >
        <div>
          <Form
            form={editDetailsForm}
            className="dpr-settings-spares-modal-form"
            name="basic"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={24}>
              <Col lg={8}>
                <Form.Item label="Equipment Type" name="equipmentType" required>
                  <Input
                    placeholder={'Enter New Equipment Type'}
                    // value={equipmentSerialNumber}
                    // onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    disabled={editValue}
                  />
                  {/* <Select
                                        className='client-select'
                                        placeholder='Select Equipment Type'
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                    onChange={onChangeEquipment}
                                    disabled={editValue}
                                    filterOption={(input, option) =>
                                        (option.children).toLowerCase().includes(input.toLowerCase())
                                    // }
                                    >
                                        {productHierarchyList && productHierarchyList.map((item, i) =>
                                        <Option key={i} value={item && item.name}>{item && item.name}</Option>)}
                                    </Select> */}
                </Form.Item>
              </Col>
              {/* <Col lg={8}>
                                <Form.Item
                                    label="Equipment SI No"
                                    name="equipmentSerialNumber"
                                    required
                                >
                                    <Input
                                        placeholder={'Enter New Equipment SI No'}
                                        // value={equipmentSerialNumber}
                                        // onChange={(e) => setEquipmentType(e.target.value)}
                                        size="large"
                                        disabled={editValue}
                                    /> */}
              {/* <Select
                                    className='client-select'
                                    placeholder='Select Equipment SI No'
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    // onChange={onChangeEquipment}
                                    disabled={editValue}
                                    filterOption={(input, option) =>
                                        (option.children).toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {productHierarchyList && productHierarchyList.map((item, i) =>
                                        <Option key={i} value={item && item.name}>{item && item.name}</Option>)}
                                </Select> */}
              {/* </Form.Item>
                            </Col> */}
              <Col lg={8}>
                <Form.Item label="SAP KIT No" name="sapKitNo" required>
                  <Input
                    placeholder={'Enter New SAP KIT No'}
                    // value={equipmentType}
                    // onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    disabled={editValue}
                  />
                  {/* <Select
                                    className='client-select'
                                    placeholder='Select SAP KIT No'
                                    showSearch
                                    allowClear
                                    optionFilterProp="children"
                                    // onChange={onChangeEquipment}
                                    disabled={editValue}
                                    filterOption={(input, option) =>
                                        (option.children).toLowerCase().includes(input.toLowerCase())
                                    }
                                >
                                    {productHierarchyList && productHierarchyList.map((item, i) =>
                                        <Option key={i} value={item && item.name}>{item && item.name}</Option>)}
                                </Select> */}
                </Form.Item>
              </Col>

              <Col lg={8}>
                <Form.Item label="SAP Number" name="sapNumber" required>
                  <Input
                    placeholder={'Enter New SAP Number'}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    disabled={editValue}
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item label="Description" name="description" required>
                  <Input
                    placeholder={'Enter New Description'}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    disabled={editValue}
                  />
                </Form.Item>
              </Col>
              {/* <Col lg={8}>
                                <Form.Item
                                    label="Unit"
                                    name="unit"
                                    required
                                >
                                    <Input
                                        placeholder={'Enter  Unit'}
                                        value={equipmentType}
                                        onChange={(e) => setEquipmentType(e.target.value)}
                                        size="large"
                                        disabled={editValue}
                                    />
                                </Form.Item>
                            </Col> */}
              <Col lg={8}>
                <Form.Item
                  label="Target Stock"
                  name="targetStock"
                  disabled={editValue}
                  rules={[
                    { required: true, message: 'Please enter target stock' },
                    {
                      validator: (_, value) => {
                        if (value && value < 0) {
                          return Promise.reject('Target stock cannot be negative');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder={'Enter Safety Stock'}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    type="number"
                    min="0"
                    size="large"
                    disabled={editValue}
                  />
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item label="Cost" name="cost" required>
                  <Input
                    placeholder={'Enter New Cost'}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    disabled={editValue}
                  />
                </Form.Item>
              </Col>

              <Col lg={8}>
                <Form.Item label="Currency" name="currency" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select Currency"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    value={currency}
                    disabled={editValue}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    <Option value="dollar">Dollar</Option>
                    <Option value="pound">Pound</Option>
                    <Option value="euro">Euro</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={editValue ? 8 : 8}>
                <Form.Item
                  label="Actual Stock"
                  name="actualStock"
                  required
                  rules={[
                    { required: true, message: 'Please enter actual stock' },
                    {
                      validator: (_, value) => {
                        if (value && value < 0) {
                          return Promise.reject('Actual stock cannot be negative');
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    placeholder={'Enter Actual Stock'}
                    value={equipmentType}
                    onChange={(e) => setEquipmentType(e.target.value)}
                    size="large"
                    type="number"
                    min="0"
                    disabled={editValue}
                  />
                </Form.Item>
              </Col>
              {/* {
                                editValue && <Col lg={4}>
                                    <Form.Item
                                        label="Current QTY"
                                        name="initialQty"
                                        required
                                    >
                                        <Input
                                            // placeholder={'Enter New QTY'}
                                            value={equipmentType}
                                            onChange={(e) => setEquipmentType(e.target.value)}
                                            size="large"
                                            type='number'
                                            disabled={editValue}
                                        />
                                    </Form.Item>
                                </Col>
                            } */}

              <Col lg={8}>
                <Form.Item label="Location" name="location">
                  <Input placeholder={'Enter Location'} size="large" />
                </Form.Item>
              </Col>
              {editValue && (
                <Col lg={8}>
                  <Form.Item
                    label="Pending Stock"
                    name="pendingStock"
                    rules={[
                      {
                        validator: (_, value) => {
                          if (value && value < 0) {
                            return Promise.reject('Add new quantity cannot be negative');
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      placeholder="Enter New QTY"
                      value={pendingStock}
                      defaultValue="0"
                      // onChange={(e) => {
                      //   const newQuantity = e.target.value;
                      //   const parsedNewQty = newQuantity === '' ? 0 : parseInt(newQuantity);
                      //   if (parsedNewQty >= 0) {
                      //     setNewQty(newQuantity);
                      //     editDetailsForm.setFieldsValue({
                      //       initialQty: parseInt(initialQty) + parsedNewQty,
                      //     });
                      //   }
                      // }}
                      onKeyPress={handleKeyPress}
                      size="large"
                      type="number"
                      min="0"
                    />
                  </Form.Item>
                </Col>
              )}
            </Row>
          </Form>
        </div>
      </Modal>
      <Modal
        title="Delete spare"
        centered
        visible={isDeleteModalVisible}
        onCancel={handleDeleteCancel}
        maskClosable={!spareDeleteFlowActive || !isSparesListLoading}
        destroyOnClose
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        className="dpr-settings-spares-delete-modal dpr-settings-spares-modern-modal"
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={handleDeleteCancel}
              disabled={isSparesListLoading && spareDeleteFlowActive}
            />
            <Button
              label={isSparesListLoading && spareDeleteFlowActive ? 'Deleting…' : 'Delete'}
              variant="primary"
              size="medium"
              onClick={handleDeleteOk}
              disabled={isSparesListLoading && spareDeleteFlowActive}
            />
          </div>
        }
      >
        <div className="dpr-settings-spares-delete-modal-body">
          <p className="dpr-settings-spares-modal-copy">
            {selectedData ? (
              <>
                Are you sure you want to delete{' '}
                <strong className="dpr-settings-spares-delete-modal-emphasis">
                  {selectedData.equipmentType}
                  {selectedData.equipmentSerialNumber != null &&
                  selectedData.equipmentSerialNumber !== ''
                    ? ` – ${selectedData.equipmentSerialNumber}`
                    : selectedData.sapNumber
                    ? ` – ${selectedData.sapNumber}`
                    : ''}
                </strong>
                ? This cannot be undone.
              </>
            ) : (
              'Are you sure you want to delete this spare? This cannot be undone.'
            )}
          </p>
        </div>
      </Modal>
      <Modal
        width={520}
        className="dpr-settings-spares-confirm-modal dpr-settings-spares-modern-modal"
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        title="Publish spare in app"
        centered
        visible={isPublishModalVisible}
        maskClosable={false}
        destroyOnClose
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button label="Cancel" variant="tertiary" size="medium" onClick={handlePublishCancel} />
            <Button
              label={isSparesListLoading ? 'Publishing…' : 'Publish'}
              variant="primary"
              size="medium"
              onClick={handlePublishApp}
              disabled={isSparesListLoading}
            />
          </div>
        }
      >
        <div>
          <p className="dpr-settings-spares-modal-copy">
            Publish will make the current spares list available in the app for this project. Continue?
          </p>
        </div>
      </Modal>
      <Modal
        width="55vw"
        className="dpr-settings-spares-form-modal dpr-settings-spares-modern-modal"
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        title="Add spare kit"
        centered
        visible={isKitModalVisible}
        maskClosable={false}
        destroyOnClose
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={handlespareModalCancel}
            />
            <Button
              label={isSparesListLoading ? 'Adding…' : 'Add'}
              variant="primary"
              size="medium"
              onClick={handleSpareAdd}
              disabled={isDisabled || isSparesListLoading}
            />
          </div>
        }
      >
        <div>
          <p className="dpr-settings-spares-modal-intro">Choose kit details and where to assign it.</p>
          <Form
            form={spareKitForm}
            className="dpr-settings-spares-modal-form"
            name="basic"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={16}>
              <Col lg={8}>
                <Form.Item label="Equipment Type" name="equipmentType" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select Equipment Type"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={onChangeSpareEquipmentType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isSparesEuipTypeLoading && <Option key={'loading'} value={'Loading...'} />}
                    {!isSparesEuipTypeLoading &&
                      equipmentTypeList?.map((item, i) => (
                        <Option key={i} value={item.equipmentType}>
                          {item.equipmentType}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={8}>
                <Form.Item label="SAP KIT No" name="sapKitNo" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select SAP KIT No"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={(value) => setEquipmentSapKitNo(value)}
                    disabled={!equipmentType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isSparesSapKitNoLoading && <Option key={'loading'} value={'Loading...'} />}
                    {!isSparesSapKitNoLoading &&
                      sapKitNoList?.map((item, i) => (
                        <Option key={i} value={item && item.sapSparesKitNumber}>
                          {item && item.sapSparesKitNumber}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={8}>
                <Form.Item label="Quantity" name="quantity" required>
                  <Input
                    placeholder={'Enter New QTY'}
                    value={equipmentType}
                    // onChange={(e) => setEquipmentType(e.target.value)}
                    onKeyPress={handleKeyPress}
                    min={1}
                    type="number"
                    size="large"
                  />
                </Form.Item>
              </Col>

              <Col lg={24}>
                <h6 className="dpr-settings-spares-modal-section-title">Assign to</h6>
              </Col>
              <Col lg={6}>
                <Form.Item label="Serial No. in Project" name="assignTo">
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select Serial No"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    disabled={serialNoToAssign}
                    // onChange={onChangeSpareEquipmentType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isEquipmentSnLoading && <Option key={'loading'} value={'Loading...'} />}
                    {!isEquipmentSnLoading &&
                      serialNumberList?.map((item, i) => (
                        <Option key={i} value={item.serialNumber}>
                          {item.serialNumber}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {isSerialNoToAssign && (
            <p className="dpr-settings-spares-modal-warning">
              *Please add{' '}
              <strong className="dpr-settings-spares-modal-warning-strong">
                {equipmentType + ' - ' + equipmentSN}
              </strong>{' '}
              to the project for assigning spares.
            </p>
          )}
          {equipmentSN == 'All' && serialNumberList.length == 0 && (
            <p className="dpr-settings-spares-modal-warning">
              *Please add{' '}
              <strong className="dpr-settings-spares-modal-warning-strong">Serial Number</strong> to
              the project for assigning spares.
            </p>
          )}
        </div>
      </Modal>
      <Modal
        title="Spare Already Exists"
        centered
        visible={showDuplicateModal}
        maskClosable={false}
        destroyOnClose
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        className="dpr-settings-spares-delete-modal dpr-settings-spares-modern-modal"
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={() => {
                setShowDuplicateModal(false);
                setDuplicatePayload(null);
              }}
            />
            <Button
              label={isSparesListLoading ? 'Confirming…' : 'Confirm'}
              variant="primary"
              size="medium"
              onClick={async () => {
                try {
                  if (duplicatePayload) {
                    await onAddIndvSpare(duplicatePayload);
                    setTimeout(handleAddIndvSpareModalCancel(), 1000);
                  }
                  setShowDuplicateModal(false);
                  setDuplicatePayload(null);
                } catch (err) {
                  console.log(err);
                }
              }}
              disabled={isSparesListLoading}
            />
          </div>
        }
      >
        <div className="dpr-settings-spares-delete-modal-body">
          <p className="dpr-settings-spares-modal-copy">
            The spare <strong className="dpr-settings-spares-delete-modal-emphasis">{duplicatePayload?.existingSpare?.equipmentType}</strong> already exists in the project.
          </p>
          <ul style={{ margin: '16px 0', paddingLeft: '20px', color: '#555', fontSize: '14px' }}>
            <li style={{ marginBottom: '8px' }}>Current Target Stock: <strong>{duplicatePayload?.existingSpare?.targetStock || 0}</strong></li>
            <li style={{ marginBottom: '8px' }}>Current Actual Stock: <strong>{duplicatePayload?.existingSpare?.actualStock || 0}</strong></li>
            <li style={{ marginBottom: '8px' }}>Quantity to Add: <strong>{duplicatePayload?.payload?.quantity || 0}</strong></li>
            <li style={{ marginBottom: '8px' }}>Target Stock after adding: <strong>{(Number(duplicatePayload?.existingSpare?.targetStock || 0) + Number(duplicatePayload?.payload?.quantity || 0))}</strong></li>
            <li>Actual Stock after adding: <strong>{(Number(duplicatePayload?.existingSpare?.actualStock || 0) + Number(duplicatePayload?.payload?.quantity || 0))}</strong></li>
          </ul>
          <p className="dpr-settings-spares-modal-copy">
            Adding this will append the new quantity to the existing stock. Do you want to continue?
          </p>
        </div>
      </Modal>
      <Modal
        width="55vw"
        className="dpr-settings-spares-form-modal dpr-settings-spares-modern-modal"
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        title="Add individual spare"
        centered
        visible={showAddSpareModal}
        maskClosable={false}
        destroyOnClose
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={handleAddIndvSpareModalCancel}
            />
            <Button
              label={isSparesListLoading ? 'Adding…' : 'Add'}
              variant="primary"
              size="medium"
              onClick={handleAddIndvSpare}
              disabled={isSparesListLoading}
            />
          </div>
        }
      >
        <div>
          <p className="dpr-settings-spares-modal-intro">Select a part and assign it to equipment.</p>
          <Form
            form={addIndSpareForm}
            className="dpr-settings-spares-modal-form"
            name="basic"
            layout="vertical"
            autoComplete="off"
          >
            <Row gutter={16}>
              <Col lg={8}>
                <Form.Item label="Equipment Type" name="equipmentType" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select Equipment Type"
                    showSearch
                    allowClear
                    loading={fetchLoading}
                    optionFilterProp="children"
                    onChange={onChangeSpareEquipmentType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isSparesEuipTypeLoading && <Option key={'loading'} value={'Loading...'} />}
                    {!isSparesEuipTypeLoading &&
                      equipmentTypeList?.map((item, i) => (
                        <Option key={i} value={item.equipmentType}>
                          {item.equipmentType}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              {/* <Col lg={8}>
                                <Form.Item
                                    label="Equipment SI No"
                                    name="equipmentSerialNumber"
                                    required
                                >
                                    <Select
                                        className='client-select'
                                        placeholder='Select Equipment SI No'
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        onChange={onChangeSpareEquipmentSn}
                                        disabled={!equipmentType}
                                        filterOption={(input, option) =>
                                            (option.children).toLowerCase().includes(input.toLowerCase())
                                        }
                                    >
                                        {isSparesEuipSnLoading && <Option key={'loading'} value={'Loading...'} />}
                                        {!isSparesEuipSnLoading && serialNoList?.map((item, i) =>
                                            <Option key={i} value={item.equipmentSerialNumber}>{item.equipmentSerialNumber}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col> */}
              <Col lg={8}>
                <Form.Item label="SAP KIT No" name="sapKitNo" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select SAP KIT No"
                    showSearch
                    allowClear
                    loading={fetchLoading}
                    optionFilterProp="children"
                    onChange={onChangesapKitNo}
                    disabled={!equipmentType}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isSparesSapKitNoLoading && <Option key={'loading'} value={'Loading...'} />}
                    {!isSparesSapKitNoLoading &&
                      sapKitNoList?.map((item, i) => (
                        <Option key={i} value={item && item.sapSparesKitNumber}>
                          {item && item.sapSparesKitNumber}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={8}>
                <Form.Item label="SAP Number" name="sapNumber" required>
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select SAP Number"
                    showSearch
                    allowClear
                    optionFilterProp="children"
                    onChange={(value) => onChangeSapNumber1(value)}
                    onSelect={(value) => OnChangeSapNumber(value)}
                    //disabled={!equipmentType || !equipmentSapKitNo}
                    // filterOption={(input, option) =>
                    //     (option.children).toLowerCase().includes(input.toLowerCase())
                    // }
                  >
                    {sapNumberList && sapNumberList.length > 0 ? (
                      <>
                        {isSparesSapNoLoading ? (
                          <Option key="loading" value="Loading...">
                            Loading...
                          </Option>
                        ) : (
                          sapNumberList.map((item, i) => (
                            <Option key={i} value={item?.partSapNumber}>
                              {item?.partSapNumber}
                            </Option>
                          ))
                        )}
                      </>
                    ) : (
                      sapNumberTotalList?.map((item, i) => (
                        <Option key={i} value={item?.partSapNumber}>
                          {item?.partSapNumber}
                        </Option>
                      ))
                    )}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={8}>
                <Form.Item label="Quantity" name="quantity" required>
                  <Input
                    placeholder={'Enter New QTY'}
                    value={equipmentType}
                    // onChange={(e) => setEquipmentType(e.target.value)}
                    onKeyPress={handleKeyPress}
                    min={1}
                    type="number"
                    size="large"
                  />
                </Form.Item>
              </Col>

              <Col lg={24}>
                <h6 className="dpr-settings-spares-modal-section-title">Assign to</h6>
              </Col>
              <Col lg={12}>
                <Form.Item label="Serial No. in Project" name="assignTo">
                  <Select
                    {...SPARES_MODAL_SELECT_PROPS}
                    className="dpr-settings-spares-modal-select"
                    placeholder="Select Serial No"
                    showSearch
                    allowClear
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {isEquipmentSnLoading && (
                      <Option key={'loading'} value={'Loading...'}>
                        Loading...
                      </Option>
                    )}
                    {!isEquipmentSnLoading &&
                      equipmentSn?.map((item, i) => (
                        <Option
                          key={i}
                          value={item.pihEquipmentId}
                          label={`${item.serialNumber} ${
                            item?.equipmentType && `(${item.equipmentType})`
                          }`}
                        >
                          {item.serialNumber} {item?.equipmentType && `(${item.equipmentType})`}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <Modal
        width={480}
        className="dpr-settings-spares-upload-modal dpr-settings-spares-modern-modal"
        wrapClassName="dpr-settings-spares-ant-modal-wrap"
        title="Upload spares"
        centered
        visible={openUploadModal}
        maskClosable={false}
        destroyOnClose
        footer={
          <div className="dpr-settings-spares-modal-footer">
            <Button
              label="Cancel"
              variant="tertiary"
              size="medium"
              onClick={handleCancelUploadFile}
            />
            <Button
              label={uploading ? 'Uploading…' : 'Upload'}
              variant="primary"
              size="medium"
              onClick={handleUploadFile}
              disabled={uploading}
            />
          </div>
        }
      >
        <div className="dpr-settings-spares-upload-modal-warning-wrap">
          <p className="dpr-settings-spares-modal-warning">
            <strong>Warning:</strong> Uploading this Excel file will replace all existing spares data
            for this project with the contents of the file.
          </p>
        </div>
        <div className="uploadFile_admin">
          <Upload
            {...fileProps}
            maxCount={1}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          >
            <AntdButton disabled={disableFileUpload} icon={<CloudUploadOutlined className="icon-22" />}>
              Select File
            </AntdButton>
          </Upload>
        </div>
      </Modal>
      {showExpandModal && (
        <SparesExpandView
          onClose={() => setShowExpandModal(false)}
          showModal={showModal}
          setIsKitModalVisible={setIsKitModalVisible}
          handlePublish={handlePublish}
          handleDownloadExcelSheet={handleDownloadExcelSheet}
          handleDownloadTemplate={handleDownloadTemplate}
          setOpenUploadModal={setOpenUploadModal}
          gridProps={{
            sortedRows: paginatedSparesRows,
            isLoading: isExcelSparesListLoading || isSparesListLoading,
            current,
            pageSize: currentPagesize,
            sortKey,
            sortDir,
            onToggleSort: toggleSparesSort,
            formatAssignedToCell,
            formatCostCell,
            totalCostDisplay,
            onEdit: showEditModal,
            onDelete: showDeleteModal,
            equipmentTypeValue,
            assignedToSerialNumberValue,
            equipmentSubCategory,
            sapKitNo,
            sapNumber,
            description,
            safetyStock,
            cost,
            onServerFilterChange: handleFilterChange,
            setEquipmentTypeValue,
            setAssignedToSerialNumberValue,
            setEquipmentSubCategory,
            setSapKitNo,
            setSapNumber,
            setDescription,
            setSafetyStock,
            setCost,
            localColFilters,
            onLocalColFilterChange,
            renderTextColumnFilterTrigger,
          }}
          filteredSparesCount={filteredSparesCount}
          totalSparesCount={totalSparesCount}
          current={current}
          setCurrent={setCurrent}
          currentPagesize={currentPagesize}
          setCurrentPagesize={setCurrentPagesize}
          isWriteAccess={isWriteAccess}
        />
      )}
      <SpareOrderHistoryModal
        open={openOrderHistoryModal}
        projectId={selectedProject?.id}
        onClose={() => setOpenOrderHistoryModal(false)}
      />
    </div>
  );
};

const mapStateToProps = ({ spareDashBoardReducer, equip }) => {
  const sparesList = get(spareDashBoardReducer, 'sparesDashBoardList', []);
  const excelSparesList = get(spareDashBoardReducer, 'ExcelSparesDashBoardList', []);
  const isSparesListLoading = get(spareDashBoardReducer, 'isFetchsparesDashBoardDataLoading', []);
  const isExcelSparesListLoading = get(
    spareDashBoardReducer,
    'isExcelSparesEuipTypeDataLoading',
    []
  );
  //add spare kit
  const sparesEuipType = get(spareDashBoardReducer, 'sparesEuipTypeData', []);
  const sparesEuipSn = get(spareDashBoardReducer, 'sparesEuipSnData', []);
  const equipmentSn = get(spareDashBoardReducer, 'euipmentSnData', []);
  const sparesSapKitNo = get(spareDashBoardReducer, 'sparesSapKitNoData', []);
  const sparesSapNo = get(spareDashBoardReducer, 'sparesSapNoData', []);
  const isSparesEuipTypeLoading = get(spareDashBoardReducer, 'isSparesEuipTypeDataLoading', []);
  const isSparesEuipSnLoading = get(spareDashBoardReducer, 'isSparesEuipSnDataLoading', []);
  const isEquipmentSnLoading = get(spareDashBoardReducer, 'isFetchingEuipmentSnDataLoading', []);
  const isSparesSapKitNoLoading = get(spareDashBoardReducer, 'isSparesSapKitNoDataLoading', []);
  const sparesDataCount = get(spareDashBoardReducer, 'sparesDataCount', []);
  const isSparesSapNoLoading = get(spareDashBoardReducer, 'isSparesSapNoDataLoading', []);
  const sparesSubcategoryData = get(spareDashBoardReducer, 'sparesSubcategoryData', []);
  const isSparesDashSubcategoryLoading = get(
    spareDashBoardReducer,
    'isSparesDashSubcategoryLoading',
    []
  );
  const equipDetails = get(equip, 'equipData', []);

  return {
    sparesList,
    excelSparesList,
    sparesDataCount,
    isSparesListLoading,
    isExcelSparesListLoading,
    //
    sparesEuipType,
    sparesEuipSn,
    equipmentSn,
    sparesSapKitNo,
    sparesSapNo,
    isSparesEuipTypeLoading,
    isSparesEuipSnLoading,
    isEquipmentSnLoading,
    isSparesSapKitNoLoading,
    isSparesSapNoLoading,
    equipDetails,
    sparesSubcategoryData,
    isSparesDashSubcategoryLoading,
  };
};

const mapDispatchToProps = {
  onFetchSparesDashBoardList: fetchSparesDashBoardList,
  onFetchExcelSparesDashBoardList: fetchExcelSparesDashBoardList,
  onGetPihEquipmentTypes: fetchsparesEuipTypeList,
  onGetSparesEquipmentSn: fetchsparesEuipSNList,
  onGetEquipmentSn: fetchEuipSNList,
  onGetSparesEquipmentKitNo: fetchSapKitNoList,
  onGetSparesEquipmentSapNo: fetchSapNoList,
  onAddIndvSpare: addIndvSpare,
  onAddSpareKit: addSpareKit,
  onUpdateSpareList: updateDashboardSpare,
  onPublishDashboardList: publishDashboardList,
  onDeleteDashboardSpare: deleteDashboardSpare,
  onFetchSubcategory: fetchSubcategory,
};

export default connect(mapStateToProps, mapDispatchToProps)(SpareDashboard);
